<template>
  <vertical-modal width="tn" :visible="visible"
                  @close="close"
                  body-class="tw-overflow-y-auto"
                  header-title="ارسال مجدد پیامک پرداختنی">
    <template #body>
      <div class="tw-border-b tw-border-blue-dark-50 tw-p-6 tw-relative" v-for="(item, index) in mobiles">
        <input-ayandeh
          v-model:value="item.mobile"
          placeholder="شماره موبایل را وارد کنید"
          base-icon="mobile"
          label-class="tw-mb-3"
          :label="'موبایل ' + (index + 1)"
          class="tw-text-right"
          dir="ltr">
        </input-ayandeh>
      </div>
      <div class="tw-py-[22px] tw-text-center tw-text-blue-dark-400 tw-border-b tw-border-blue-dark-50">
        <div class="tw-cursor-pointer" @click="addMobile">
          <base-icon icon="add" class="tw-0ml-3 tw-align-middle" />
          <span class="tw-text-tiny tw-font-bold">افزودن شماره موبایل جدید</span>
        </div>
      </div>
    </template>

    <template #footer>
      <new-btn variant="outline"
               color="primary"
               :border="false"
               :disabled="send_sms_loading"
               @click="close">بستن
      </new-btn>
      <new-btn variant="outline"
               color="primary"
               :disabled="send_sms_loading"
               :loading="send_sms_loading"
               @click="send_sms_again">
        <base-icon icon="sms" class="tw-ml-2 tw-align-middle" />
        ارسال پیامک
      </new-btn>
    </template>
  </vertical-modal>
</template>

<script setup>

import VerticalModal from "@/components/base/VerticalModal.vue";
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import Currency from "@/components/partial/Currency.vue";
import {getCurrentInstance, onMounted, ref} from "vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";

const props = defineProps({
  payment_able: {type: Object, default: null},
  visible: { type: Boolean, default: false},
})
const { proxy } = getCurrentInstance()
const emit = defineEmits(['close'])
const send_sms_loading = ref(false)
const mobiles = ref([])

onMounted(() => {
  addMobile()
})
const close = () => {
  emit('close', true)
}

const addMobile = () => {
  mobiles.value.push({ mobile: ''})
}

const resetModalData = () => {
  mobiles.value = []
  addMobile()
}

const send_sms_again = () => {
  send_sms_loading.value = true
  try {
    let response = axios.post('/paymentable/send_again_sms_payed/' + props.payment_able.id, {
        mobiles: mobiles.value.map(item => item.mobile)
      })

    proxy.$my_alert(response?.data?.message, response?.data?.status)
    close()

  } catch (e) {
    proxy.$my_alert(e.message, 'error')
  } finally {
    send_sms_loading.value = false
  }
}
</script>

<style scoped>

</style>
